"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var idm_report_export_service_client_js_2 = require("@synisys/idm-report-export-service-client-js");
var idm_report_export_service_client_js_3 = require("@synisys/idm-report-export-service-client-js");
var idm_report_export_service_client_js_4 = require("@synisys/idm-report-export-service-client-js");
var text_style_converter_1 = require("./text-style-converter");
/**
 * Convert formatting condition json to according formatting condition dto
 *
 * Created by Hayk.Andriasyan on 4/19/2018.
 */
var FormattingConditionConverter = /** @class */ (function () {
    function FormattingConditionConverter() {
    }
    FormattingConditionConverter.convertJsonToConstantFormattingCondition = function (formattingConditionJson) {
        var conditionDto = new idm_report_export_service_client_js_1.ConstantFormattingConditionDto();
        FormattingConditionConverter.setFormattingConditionProperties(formattingConditionJson, conditionDto);
        conditionDto.measureElementBranchIndex = formattingConditionJson.measureElementBranchIndex;
        conditionDto.value = formattingConditionJson.value;
        return conditionDto;
    };
    FormattingConditionConverter.convertJsonToBetweenFormattingCondition = function (formattingConditionJson) {
        var conditionDto = new idm_report_export_service_client_js_2.BetweenFormattingConditionDto();
        FormattingConditionConverter.setFormattingConditionProperties(formattingConditionJson, conditionDto);
        conditionDto.measureElementBranchIndex = formattingConditionJson.measureElementBranchIndex;
        conditionDto.valueFrom = formattingConditionJson.valueFrom;
        conditionDto.valueTo = formattingConditionJson.valueTo;
        return conditionDto;
    };
    FormattingConditionConverter.convertJsonToMeasureToMeasureComparisonFormattingCondition = function (formattingConditionJson) {
        var conditionDto = new idm_report_export_service_client_js_3.MeasureToMeasureComparisonFormattingConditionDto();
        FormattingConditionConverter.setFormattingConditionProperties(formattingConditionJson, conditionDto);
        conditionDto.measureElement1BranchIndex = formattingConditionJson.measureElement1BranchIndex;
        conditionDto.measureElement2BranchIndex = formattingConditionJson.measureElement2BranchIndex;
        return conditionDto;
    };
    /**
     * Check whether json represents between formatting condition
     */
    FormattingConditionConverter.isInstanceOfBetweenFormattingCondition = function (formattingConditionJson) {
        return formattingConditionJson.hasOwnProperty('valueFrom') && formattingConditionJson.hasOwnProperty('valueTo');
    };
    /**
     * Check whether json represents constant formatting condition
     */
    FormattingConditionConverter.isInstanceOfConstantFormattingCondition = function (formattingConditionJson) {
        return formattingConditionJson.hasOwnProperty('value');
    };
    /**
     * Check whether json represents measure to measure formatting condition
     */
    FormattingConditionConverter.isInstanceOfMeasureToMeasureComparisonFormattingCondition = function (formattingConditionJson) {
        return formattingConditionJson.hasOwnProperty('measureElement1BranchIndex') && formattingConditionJson.hasOwnProperty('measureElement2BranchIndex');
    };
    FormattingConditionConverter.setFormattingConditionProperties = function (formattingConditionJson, formattingCondition) {
        formattingCondition.booleanOperator =
            idm_report_export_service_client_js_4.BooleanOperatorDtoFactory.newInstance(formattingConditionJson.booleanOperator['booleanOperatorType']);
        formattingCondition.textStyle = text_style_converter_1.TextStyleConverter.convertJsonToTextStyleDto(formattingConditionJson['textStyle']);
    };
    return FormattingConditionConverter;
}());
exports.FormattingConditionConverter = FormattingConditionConverter;
//# sourceMappingURL=formatting-condition-converter.js.map